import { captureMiddlewareError } from './captureMiddlewareError'
import { captureMiddlewarePerformance } from './captureMiddlewarePerformance'
import { getMiddlewareHeaders } from './getMiddlewareHeaders'
import { getMiddlewareUrl } from './getMiddlewareUrl'

/**
 * Submits form
 * @param {SubmitBody} payload - The payload
 * @returns {Promise<FormSubmitResponse>}
 */
export async function formSubmit(payload) {
  const apiBase = getMiddlewareUrl()
  const endpoint = '/api/form-submit'
  const url = `${apiBase}${endpoint}`

  const startTime = performance.now()
  try {
    const body = JSON.stringify(payload)
    const response = await fetch(url, {
      body,
      headers: getMiddlewareHeaders(),
      method: 'POST',
    })

    captureMiddlewarePerformance(url, performance.now() - startTime)

    if (response.ok) {
      const data = await response.json()
      return data || {}
    }

    throw Error(
      response.statusText || `${response.status}`.trim() || 'Unknown error',
    )
  } catch (error) {
    captureMiddlewarePerformance(url, performance.now() - startTime)
    captureMiddlewareError(url, /** @type {Error} */ (error))
    return {}
  }
}
